import React from 'react';
import { LuTriangleAlert, LuClock, LuMapPinOff } from 'react-icons/lu';

// Avisos del día armado (25-oct-2026), con la acción a un toque: urgentes que quedaron en otra zona,
// urgentes sin ubicar en el mapa y tiempo que sobra porque se llegó al máximo de equipos.
const caja = 'flex items-start gap-2.5 px-3.5 py-3 rounded-2xl text-caption';
const boton = 'h-8 px-3 shrink-0 rounded-lg text-label font-black active:scale-95';

export default function AvisosArmarDia({ plan, tope, onTope, onZona }) {
    if (!plan) return null;
    const urg = plan.afuera.filter(p => p.prioridad === 'URGENTE');
    const nombreZona = id => plan.zonas?.find(z => z.id === id)?.nombre || id;
    const porZona = {};
    urg.filter(p => p.motivoAfuera === 'Es de otra zona').forEach(p => { (porZona[p.zona] = porZona[p.zona] || []).push(p); });
    const sinUbicar = urg.filter(p => /ubicado/i.test(p.motivoAfuera || ''));
    // Sobra tiempo: llegó al máximo y termina más de hora y media antes del fin de la jornada
    const aMin = h => { const [a, b] = String(h || '0:0').split(':').map(Number); return a * 60 + b; };
    const sobra = tope && plan.equipos >= tope && plan.terminaA && plan.finJornada && aMin(plan.finJornada) - aMin(plan.terminaA) >= 90;
    return (
        <div className="space-y-2">
            {Object.entries(porZona).map(([zona, lista]) => (
                <div key={zona} className={`${caja} bg-[rgba(201,52,31,0.10)] text-ink`}>
                    <LuTriangleAlert size={16} className="shrink-0 mt-0.5 text-brand-red" />
                    <span className="flex-1 min-w-0">
                        <b>{lista.length} urgente{lista.length !== 1 ? 's' : ''} en {nombreZona(zona)}</b>
                        <span className="block text-muted truncate">{lista.map(p => p.nombre).join(' · ')}</span>
                    </span>
                    <button type="button" onClick={() => onZona(zona)} className={`${boton} bg-brand-red text-white`}>Ver {nombreZona(zona)}</button>
                </div>
            ))}
            {sinUbicar.length > 0 && (
                <div className={`${caja} bg-panel text-ink`}>
                    <LuMapPinOff size={16} className="shrink-0 mt-0.5 text-brand-red" />
                    <span className="flex-1 min-w-0">
                        <b>{sinUbicar.length} urgente{sinUbicar.length !== 1 ? 's' : ''} sin ubicar: {sinUbicar.map(p => p.nombre).join(' · ')}</b>
                        <span className="block text-muted">No entra{sinUbicar.length !== 1 ? 'n' : ''} en ninguna ruta hasta que corrijas la dirección o lo ubiques en el Mapa.</span>
                    </span>
                </div>
            )}
            {sobra && (
                <div className={`${caja} bg-panel text-ink`}>
                    <LuClock size={16} className="shrink-0 mt-0.5 text-secondary" />
                    <span className="flex-1 min-w-0">
                        <b>Terminás ~{plan.terminaA}</b>
                        <span className="block text-muted">La jornada va hasta las {plan.finJornada}: llegaste al máximo de {tope} equipos y te sobra tiempo.</span>
                    </span>
                    <button type="button" onClick={() => onTope(tope + 1)} className={`${boton} bg-ink text-page`}>Subir a {tope + 1}</button>
                </div>
            )}
        </div>
    );
}
